export default {"src":"/_next/static/media/play_basic_icon_n500.c2709298.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};